// store/store.ts
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import userReducer from "./slices/userSlice";
import walletReducer from "./slices/walletSlice";
import adminReducer from "./slices/adminSlice";
import airdropReducer from "./slices/airdropSlice";
import dashboardReducer from "./slices/dashboardSlice";
import supportReducer from "./slices/supportSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    wallet: walletReducer,
    admin: adminReducer,
    airdrop: airdropReducer,
    dashboard: dashboardReducer,
    support: supportReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // serializableCheck: false,
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ["user/submitKYC/pending"],
        // Ignore these field paths in all actions
        ignoredActionPaths: ["meta.arg", "payload.timestamp"],
        // Ignore these paths in the state
        ignoredPaths: ["items.dates"],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
